import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Los sistemas agrupan los componentes: "Motor", "Hidráulico", "Eléctrico", "Tren de rodaje".',
    'Definí los sistemas antes de agregar componentes; cada componente pertenece a un sistema.',
    'Usá nombres que el equipo técnico reconozca al instante.',
  ],
  nextSteps: [
    'Crear los Componentes dentro de cada sistema.',
    'Las tareas de mantenimiento se asociarán a componentes específicos.',
  ],
};

const ConfiguracionSistemas = () => (
  <ConfiguracionBase
    apiEndpoint="sistemas"
    titulo="Sistemas"
    descripcion="Agrupa componentes por sistema (ej: Combustible, Hidráulico, Eléctrico)"
    icon="fas fa-sitemap"
    compact
    help={HELP}
  />
);

export default ConfiguracionSistemas;
